
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"newRetainerClientMeetingMinutes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retainerClientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attendees"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agenda"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conclusion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discussion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientFeedback"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignmentsMinutes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RetainerAssignmentMinutesInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldMeetingTopicsMinutes"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OldMeetingTopicsMinutesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newMeetingTopicsMinutes"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NewMeetingTopicsMinutesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalMeeting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newRetainerClientMeetingMinutes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retainerClientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retainerClientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"attendees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attendees"}}},{"kind":"Argument","name":{"kind":"Name","value":"agenda"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agenda"}}},{"kind":"Argument","name":{"kind":"Name","value":"conclusion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conclusion"}}},{"kind":"Argument","name":{"kind":"Name","value":"discussion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discussion"}}},{"kind":"Argument","name":{"kind":"Name","value":"suggestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientFeedback"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientFeedback"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignmentsMinutes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignmentsMinutes"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldMeetingTopicsMinutes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldMeetingTopicsMinutes"}}},{"kind":"Argument","name":{"kind":"Name","value":"newMeetingTopicsMinutes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newMeetingTopicsMinutes"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalMeeting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalMeeting"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":896}};
    doc.loc.source = {"body":"mutation newRetainerClientMeetingMinutes (\n  $retainerClientId: Int!\n  $date: String!\n  $attendees: [String!]!\n  $agenda: String\n  $conclusion: String\n  $discussion: String\n  $suggestion: String\n  $clientFeedback: String\n  $assignmentsMinutes: [RetainerAssignmentMinutesInput!]\n  $oldMeetingTopicsMinutes: [OldMeetingTopicsMinutesInput]\n  $newMeetingTopicsMinutes: [NewMeetingTopicsMinutesInput]\n  $internalMeeting: Boolean!\n) {\n  newRetainerClientMeetingMinutes (\n    retainerClientId: $retainerClientId\n    date: $date\n    attendees: $attendees\n    agenda: $agenda\n    conclusion: $conclusion\n    discussion: $discussion\n    suggestion: $suggestion\n    clientFeedback: $clientFeedback\n    assignmentsMinutes: $assignmentsMinutes\n    oldMeetingTopicsMinutes: $oldMeetingTopicsMinutes\n    newMeetingTopicsMinutes: $newMeetingTopicsMinutes\n    internalMeeting: $internalMeeting\n  ) {\n    id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["newRetainerClientMeetingMinutes"] = oneQuery(doc, "newRetainerClientMeetingMinutes");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/mutations/newRetainerClientMeetingMinutesMutation.graphql
// module id = 1156
// module chunks = 0